import { useState, useEffect } from 'react';

const getBreakpoint = (width: number): string => {
    if (width < 576) return 'xs';
    if (width >= 576 && width < 768) return 'sm';
    if (width >= 768 && width < 992) return 'md';
    if (width >= 992 && width < 1200) return 'lg';
    if (width >= 1200) return 'xl';

    return 'xs';
}

const useBreakpoint = (): string => {
    const [breakpoint, setBreakpoint] = useState(getBreakpoint(window.innerWidth));

    useEffect(() => {
        let timeoutID: number | undefined;

        const debouncedHandleResize = (...args: any[]) => {
            if (timeoutID) {
                clearTimeout(timeoutID);
            }
            timeoutID = window.setTimeout(() => {
                const currentBreakpoint = getBreakpoint(window.innerWidth);
                if (currentBreakpoint !== breakpoint) {
                    setBreakpoint(currentBreakpoint);
                }
            }, 250);
        };

        window.addEventListener('resize', debouncedHandleResize);
        return () => window.removeEventListener('resize', debouncedHandleResize);
    }, [breakpoint]);

    return breakpoint;
};

export default useBreakpoint;
